// extracted by mini-css-extract-plugin
module.exports = {"imageSlider":"EpicFeeds_imageSlider__VzoGI","image":"EpicFeeds_image__a0zHc","content":"EpicFeeds_content__UCp_I"};